<template>
  <!-- 会员中心-互助会员 -->
  <div>
    <div class="mutualMember">
      <div v-if="create_icon == 1">
        <!-- 头部查询表单 -->
        <div class="headForm">
          <div class="head">
            <div style="overflow:hidden">
              <div style="margin-bottom:20px">
                悬浮图标
              </div>
              <div>
                <div class="imgBox" style="float:left">
                  <img :src="floatingicon" alt="" />
                </div>
                <div style="float:left;margin-left:50px;width:calc(100% - 300px)">
                  <h2>悬浮图标管理</h2>
                  <div style="font-weight:400;font-size:14px;margin-top:10px;line-height:18px;color:#979797;">
                    悬浮图标是指在手机京东APP店铺首页出现悬浮的图标，买家点击图标参与店铺互动活动，图标多种多样可以<br />
                    任意选择，也支持自己上传，魔性的小图标让无线运营变的简单有效，增加店铺关注量，提升店铺粘性。
                  </div>
                  <div
                    style="font-weight:400;font-size:12px;margin-top:10px;line-height:18px;background-color:#fffaee;width:670px;padding:5px 10px;color:#979797;"
                  >
                    <i class="el-icon-info" style="color:#fe8f8a"></i>
                    注意: 1、一个店铺同一时间只能有一个活动放到APP首页的悬浮图标上；<br /><span style="margin-left:45px"
                      >2、由于京东缓存活动开启5-10分钟后，县浮图标才会在店铺首页显示。</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <el-button type="primary" style="transform:translate(46px,10px)" @click="activeShow({}, 'add')" icon="el-icon-circle-plus"
              >创建</el-button
            >
          </div>
          <div class="input-form-box">
            <input-form ref="inputForm" style="margin: 40px 0" :inputData="inputData" :btnPosition1="true" @toParentVal="searchContent"></input-form>
          </div>
        </div>
        <div class="content">
          <el-table
            :data="tableData"
            v-loading="talbeLoading"
            style="width: 100%; margintop: 20px"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <el-table-column prop="name" label="活动名称"></el-table-column>
            <el-table-column prop="date" label="悬浮图标">
              <template slot-scope="scope">
                <img :src="scope.row.imageUrl" style="width:50px;height:50px" />
              </template>
            </el-table-column>
            <el-table-column prop="note" label="活动类型">
              <template slot-scope="scope">
                <span v-if="scope.row.note == 0">其他</span>
                <span v-if="scope.row.note == 1">日历签到</span>
                <span v-if="scope.row.note == 2">浏览商品有礼</span>
                <span v-if="scope.row.note == 3">每日抢好礼</span>
                <span v-if="scope.row.note == 4">关注店铺有礼</span>
                <span v-if="scope.row.note == 5">邀请开卡有礼</span>
                <span v-if="scope.row.note == 6">邀请关注店铺</span>
                <span v-if="scope.row.note == 7">完善信息有礼</span>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="活动时间">
              <template slot-scope="scope">
                <div>起：{{ scope.row.beginTime }}</div>
                <div>止：{{ scope.row.endTime }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="活动状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == -1">已关闭</span>
                <span v-if="scope.row.status == 1">未开始</span>
                <span v-if="scope.row.status == 2">进行中</span>
                <span v-if="scope.row.status == 3">已结束</span>
                <span v-if="scope.row.status == 4">已暂停</span>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="操作" width="200px">
              <template slot-scope="scope">
                <span style="cursor:pointer;margin-right:12px;color:#fe4d45" @click="activeShow(scope.row, 'look')">查看</span>
                <span
                  v-if="scope.row.status == 1 || scope.row.status == 2"
                  style="cursor:pointer;margin-right:12px;color:#fe4d45"
                  @click="activeShow(scope.row, 'edit')"
                  >编辑</span
                >
                <span style="cursor:pointer;margin-right:12px;color:#fe4d45" @click="onshare(scope.row)">分享</span>
                <span v-if="scope.row.status == 1 || scope.row.status == 2" style="cursor:pointer;color:#fe4d45" @click="delIsvActivity(scope.row.id)"
                  >关闭活动</span
                >
                <span style="cursor:pointer;margin-right:12px;color:#fe4d45" @click="deleteActivity(scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 20px; text-align: right; margin-bottom: 20px">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="formData.current"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="formData.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              style="text-align: right; margin-top: 20px"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!--创建悬浮页  -->
      <div class="content" v-if="create_icon == 2" style="height:calc(100vh - 180px);position:relative">
        <div class="chartBox chartBox2" style="padding-bottom: 10px">
          <div class="headReturn">
            <span @click="create_icon = 1" style="cursor:pointer"> <i class="iconfont iconicon_fanhui"></i> 返回</span>
            <span style="margin: 0 20px">|</span>
            <span class="name" v-show="showEdit == 1">创建悬浮图标</span>
            <span class="name" v-show="showEdit == 2">编辑悬浮图标</span>
            <span class="name" v-show="showEdit == 3">查看悬浮图标</span>
          </div>
          <div style="margin:20px;padding:32px 0 0 4px;">
            <el-form :model="createform" label-width="100px">
              <!-- <div class="floating_img1" style="border: 1px soild #f0f0f0">
                  <img :src="createform.imageUrl" v-if="createform.imageUrl" />
                </div> -->
              <el-form-item label="活动名称" required>
                <el-input
                  v-model="createform.name"
                  maxlength="50"
                  show-word-limit
                  style="width:400px"
                  :disabled="createType == 'look'"
                  placeholder="请输入活动名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="活动时间" required>
                <el-date-picker
                  style="width:400px"
                  @input="$forceUpdate()"
                  :disabled="createType == 'look'"
                  v-model="createform.time"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="changeTime"
                  :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
                <span style="margin-left:10px">
                  活动持续<span style="color:#ff0000;margin:0 5px">{{ activityDays }}</span
                  >天<span style="color:#ff0000;margin:0 5px">{{ activityHours }}</span
                  >小时
                  <el-tooltip class="item" effect="dark" content="活动有效期不可超过订购有效期" placement="top-start">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </span>
              </el-form-item>
              <el-form-item label="活动类型" required>
                <el-select v-model="createform.note" placeholder="请选择" :disabled="createType == 'look'">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="跳转位置" required>
                <el-input v-model="createform.isvUrl" style="width:400px" :disabled="createType == 'look'"></el-input>
              </el-form-item>
              <el-form-item label="悬浮图标:" class="floating_upload" required>
                <div class="floating_img1" style="border: 1px soild #f0f0f0;display:inline-block">
                  <img :src="createform.imageUrl" v-if="createform.imageUrl" style="width:50px;height:50px" />
                  <div v-if="createform.imageUrl.length == 0" style="width:50px;height:50px;background-color:#eaeaec"></div>
                </div>
                <el-button class="status_btn3" @click="onSelecticon" style="position:absolute;top:10px;left:64px" v-if="createType != 'look'"
                  >选择图标
                </el-button>
              </el-form-item>
              <el-form-item style="text-align:center;position:absolute;bottom:20px;left:50%;transform:translateX(-50%)">
                <el-button type="primary" @click="handleAdd" v-if="createType == 'add'">立即创建</el-button>
                <el-button type="primary" @click="handleEdit" v-if="createType == 'edit'">立即修改</el-button>
                <el-button @click="create_icon = 1">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-- 分享 -->
      <el-dialog title="分享" top="20vh" :visible.sync="dialogshareVisible" :show-close="true" :before-close="qrcodeReset" width="584px">
        <div class="share">
          <span style="margin-left: 118px">请打开京东APP扫描下面二维码预览当前活动</span>
          <div class="sharecode">
            <!-- <img :src="'data:image/jpeg;base64,' + qrCode" /> -->
            <div class="qrcode" id="qrcode" ref="qrcode"></div>
          </div>
          <div class="sharefooter">
            <span>访问链接:</span>
            <!-- <el-input
                prop="shareurl"
                v-model="shareurl"
                style="width: 382px"
              ></el-input> -->
            <el-input readonly prop="shareurl" v-model="idUrl" style="width: 382px"></el-input>
            <el-button class="status_btn3" size="small" @click="CopyUrl1" style="margin-left: 10px; width: 90px">复制链接 </el-button>
          </div>
        </div>
      </el-dialog>
      <image-manage :dialoguploadVisible="dialoguploadVisible" @on-close="dialoguploadVisible = false" @on-confirm="onConfirm"></image-manage>
    </div>
    <!-- 删除活动弹框 -->
    <el-dialog title="提示" :visible.sync="outerVisibleTwo" width="400px" :before-close="closehandleDeleteTwo"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px">是否删除活动？</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDeleteTwo">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTableTwo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import inputForm from "../../components/inputForm";
import imageManage from "./image_manage";
import {
  getIsvActivityList,
  addIsvActivity,
  delIsvActivity,
  editIsvActivity,
  getActivityIdByType,
  deleteActivity,
} from "../../api/integralCenter/suspensionDiagram";
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";
export default {
  name: "",
  data() {
    return {
      status: 1,
      ids: "",
      outerVisibleTwo: false,
      floatingicon: require("../../assets/images/入口2.png"), //悬浮图标图片
      // pageName: "忠诚度管理-互动会员",
      inputData: [
        {
          name: "活动名称:",
          val: "name",
          placeholder: "请输入",
        },
        {
          name: "活动类型:",
          val: "note",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "日历签到", id: "1" },
            { label: "浏览商品有礼", id: "2" },
            { label: "每日抢好礼", id: "3" },
            { label: "关注店铺有礼", id: "4" },
            { label: "邀请开卡有礼", id: "5" },
            { label: "邀请关注店铺", id: "6" },
            { label: "完善信息有礼", id: "7" },
            // { label: "爆品优惠券", id: '1' },
            // { label: "抽奖", id: '2' },
            // { label: "其他", id: '3' },
          ],
        },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "--全部--", id: "" },
            { label: "已关闭", id: -1 },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            // { label: "已完成", id: 3 },
            // { label: "已暂停", id: 4 },
          ],
        },
        {
          name: "有效期:",
          myDate: true,
          val: ["beginTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
      ],
      create_icon: 1,
      showEdit: 1,
      dialoguploadVisible: false,
      dialogshareVisible: false,
      talbeLoading: false,
      tableData: [],
      formData: {
        current: 1,
        size: 10,
      },
      total: 10,
      qrCode: "", //活动二维码
      releaseurl: "", //发布链接
      shareurl: "", //分享链接
      //
      options: [
        { label: "其他", value: "0" },
        { label: "日历签到", value: "1" },
        { label: "浏览商品有礼", value: "2" },
        { label: "每日抢好礼", value: "3" },
        { label: "关注店铺有礼", value: "4" },
        { label: "邀请开卡有礼", value: "5" },
        { label: "邀请关注店铺", value: "6" },
        { label: "完善信息有礼", value: "7" },
      ],
      createform: {
        time: "",
        note: "0",
        name: "",
        isvUrl: "",
        imageUrl: "",
      },
      createType: "add",
      activityUrl: "",
      venderId: "",
      idUrl: "",
      activityDays: 0,
      activityHours: 0,
      // createform:{}
    };
  },
  methods: {
    getList() {
      this.talbeLoading = true;
      getIsvActivityList(this.formData).then((res) => {
        this.tableData = res.data.records;
        this.total = Number(res.data.total);
        this.talbeLoading = false;
      });
    },
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
        })
        .catch((res) => {});
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
      console.log(this.qrcode);
    },
    onshare(item) {
      this.dialogshareVisible = true;
      this.qrCode = "";
      // this.$refs.qrcode.innerHTML = "";
      let mesUrl = "";
      if (item.note == 1) {
        mesUrl = "sign_polite"; //日历签到
      } else if (item.note == 2) {
        mesUrl = "sign_polite"; // 浏览礼品有礼
      } else if (item.note == 3) {
        mesUrl = "rob_goodPresent"; //每日抢好礼
      } else if (item.note == 4) {
        mesUrl = "attention_shop"; //关注店铺有礼
      } else if (item.note == 5) {
        mesUrl = "invitationopenCard"; //邀请开卡
      } else if (item.note == 6) {
        mesUrl = "invitationattention"; //邀请关注店铺
      } else if (item.note == 7) {
        mesUrl = "perfect_information"; //完善信息
      } else if (item.note == 8) {
        mesUrl = "lottery_turntable"; //大转盘抽奖
      }
      // this.idUrl = this.activityUrl + "/" + mesUrl + "?activityId=" + item.id + "&venderId=" + this.venderId;
      this.idUrl = "http://index.yeionsms.com/yidongd/index2.html?image=" + encodeURI(item.imageUrl);
      // this.onrqCode(url);
      this.$nextTick(() => {
        let queryId = "qrcode";
        this.qrcodeAll(this.idUrl, queryId);
      });
    },
    qrcodeReset() {
      this.dialogshareVisible = false;
      this.$refs.qrcode.innerHTML = "";
    },
    //链接转二维码
    // onrqCode(url) {
    //   let content = url;
    //   rqCode({ content: content })
    //     .then((res) => {
    //       this.qrCode = res.data;
    //       console.log(this.qrCode);
    //     })
    //     .catch((res) => {
    //       this.$message.error(res.message);
    //     });
    // },
    CopyUrl1() {
      var Url2 = this.idUrl;
      var oInput = document.createElement("input");
      oInput.value = Url2;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      this.$message({
        message: "复制成功!",
        type: "success",
      });
    },
    onConfirm(url) {
      this.dialoguploadVisible = false;
      this.createform.imageUrl = url;
    },
    searchContent(item) {
      this.formData.beginTime = item.beginTime;
      this.formData.endTime = item.endTime;
      this.formData.name = item.name;
      this.formData.note = item.note;
      this.formData.status = item.status;
      this.formData.current = 1
      this.getList();
    },
    handleSizeChange(size) {
      this.formData.size = size;
      this.getList();
    },
    handleCurrentChange(current) {
      this.formData.size = current;
      this.getList();
    },
    changeTime(val) {
      if (val) {
        var difftime = (new Date(val[1]) - new Date(val[0])) / 1000;
        this.activityDays = parseInt(difftime / 86400);
        this.activityHours = parseInt(difftime / 3600) - 24 * this.activityDays;
      }
    },
    //
    onSelecticon() {
      this.dialoguploadVisible = true;
      // this.uploadform.src = "";
      // this.table = 1;
      // this.gallerytype = 1;
      // this.active = -1;
    },
    handleAdd() {
      this.createform.beginTime = this.createform.time;
      var obj = {
        beginTime: this.createform.time[0],
        endTime: this.createform.time[1],
        name: this.createform.name,
        note: this.createform.note,
        isvUrl: this.createform.isvUrl,
        imageUrl: this.createform.imageUrl,
      };
      addIsvActivity(obj).then((res) => {
        if (res.code == 0) {
          this.$message({ message: res.message, type: "warning" });
        } else {
          this.$message({ message: res.message, type: "type" });
          this.create_icon = 1;
          this.getList();
        }
      });
    },
    handleEdit() {
      var obj = {
        beginTime: this.createform.time[0],
        endTime: this.createform.time[1],
        name: this.createform.name,
        note: this.createform.note,
        isvUrl: this.createform.isvUrl,
        imageUrl: this.createform.imageUrl,
        id: this.createform.id,
      };
      editIsvActivity(obj).then((res) => {
        if (res.data.code == 0) {
          this.$message({ message: res.data.message, type: "warning" });
        } else {
          this.$message({ message: res.message, type: "success" });
          this.create_icon = 1;
          this.getList();
        }
      });
    },
    //
    activeShow(item, type) {
      this.createType = type;
      this.create_icon = 2;
      if (type == "add") {
        this.createform.name = "";
        this.createform.note = "0";
        this.createform.isvUrl = "";
        this.createform.imageUrl = "";
        this.createform.time = [this.getDay(0, "-") + " 00:00:00", this.getDay(30, "-") + " 23:59:59"];
        this.createform.beginTime = "";
        this.createform.endTime = "";
        this.showEdit = 1;
        this.activityDays = 30;
        this.activityHours = 23;
      } else {
        this.createform = JSON.parse(JSON.stringify(item));
        this.createform.time = [];
        this.createform.time[0] = item.beginTime;
        this.createform.time[1] = item.endTime;
        this.changeTime(this.createform.time);
      }
      if (type == "edit") {
        this.showEdit = 2;
      } else if (type == "look") {
        this.showEdit = 3;
      }
    },
    //关闭活动
    delIsvActivity(id) {
      this.$confirm("活动关闭后将不能再开启，是否确认关闭?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delIsvActivity({ id: id }).then((res) => {
            this.$message({ message: "关闭成功", type: "success" });
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    closehandleDeleteTwo() {
      this.outerVisibleTwo = false;
    },
    //删除活动
    deleteActivity(id) {
      this.status = id.status;
      this.outerVisibleTwo = true;
      this.ids = id.id;
    },
    // 删除
    handleDeleteTableTwo() {
      if (this.status == 2 || this.status == 1) {
        this.$message.error("先结束活动再进行删除");
        this.outerVisibleTwo = false;
      } else {
        let id = this.ids;
        deleteActivity(id)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success("删除成功");
              this.outerVisibleTwo = false;
              this.getList();
            }
          })
          .catch(() => {
            this.$message.error("删除失败");
          });
      }
    },
  },
  mounted() {
    this.getList();
    this.prefixQue();
    // getActivityIdByType().then(res=>{
    //   console.log(res,'res')
    // })
  },
  components: {
    inputForm,
    imageManage,
  },
};
</script>

<style scoped lang="scss">
.mutualMember {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1080px;
  .headForm {
    box-sizing: border-box;
    margin-top: 20px;
    padding: 24px 0 30px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .head {
      border-bottom: 1px solid #f0f0f0;
      padding: 0 0 20px 50px;
      font-size: 16px;
      font-weight: bold;
      color: #2e3458;
    }
  }
  .content {
    box-sizing: border-box;
    padding: 24px 28px 30px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin: 20px 0 50px 0;
    .btns {
      display: flex;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      span {
        padding: 10px 2px;
      }
      .b1 {
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
      }
      .b2 {
        margin: 0 30px;
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
      }
      .img3 {
        height: 18px;
        // position: flex;
        margin: 0 0 -4px 0;
      }
      .b3 {
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
.imgBox {
  flex-grow: 0;
  flex-shrink: 0;
  width: 138px;
  height: 138px;
  // border: 1px solid red;
  padding: 19px 22px;
  border-radius: 12px;
  background-color: #f2f2f2;
  // margin-bottom: 50px;

  img {
    width: 95px;
    height: 100px;
  }
}
.sharecode {
  width: 220px;
  height: 220px;
  // border: 1px solid red;
  margin-left: 168px;
  // margin-bottom: 20px;
  margin-top: 20px;
  img {
    width: 220px;
    height: 220px;
  }
}
.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #fe4d45;
    color: #ffffff;
    border-radius: 3px;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
</style>
